import { Navigate, Outlet } from 'react-router-dom'
import { ROUTES } from '@/constants'

type Props = {
  isOfferChecked: boolean
}

export const ProtectedRouteOffer = ({ isOfferChecked }: Props) =>
  isOfferChecked ? <Navigate to={ROUTES.home} /> : <Outlet />
